module.exports = __webpack_public_path__ + "img/organization-asset-group.8aa93852.png";